import Angular from "angular";
import Controller from "./new-booking-time.controller";
import Template from "./new-booking-time.html";
import Bookings from "../../services/bookings.service";

export const NewBookingTimeView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-time', [Bookings.name]);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-time/new-booking-time.js